import { Box, Center, Pressable } from 'native-base';
import React, { ReactNode, useEffect, useState } from 'react';
import { StyleSheet, TextInput } from 'react-native';
import { shallow } from 'zustand/shallow';

import useStore from 'app/hooks/useStore';
import { tID } from 'app/services/TestHelper';

export const CLICK_COUNT = 5;

const styles = StyleSheet.create({
  input: {
    textAlign: 'center',
    borderWidth: 1,
    borderColor: '#d4d4d8',
    borderRadius: 4,
    paddingHorizontal: 12,
    paddingVertical: 8,
    fontSize: 14,
  },
});

export type SecretDevToolsTriggerProps = {
  children?: ReactNode;
};

export default function SecretDevToolsTrigger({ children }: SecretDevToolsTriggerProps) {
  const [presses, setPresses] = useState(0);
  const [showInput, setShowInput] = useState(false);
  const [devTools, setDevTools] = useStore((s) => [s.devTools, s.setDevTools], shallow);

  const handleTicketPress = () => {
    setPresses(($presses) => $presses + 1);
  };
  const handleChangeText = (value: string) => {
    if (value === 'DEVTOOLS' && !devTools) setDevTools(true);
  };

  useEffect(() => {
    if (!showInput && presses >= CLICK_COUNT) {
      setShowInput(true);
    }
  }, [presses, showInput]);

  return (
    <Box testID={tID('SecretDevToolsTrigger')}>
      <Pressable testID={tID('SecretDevToolsTrigger-pressable')} onPress={handleTicketPress}>
        {children}
      </Pressable>

      {showInput && (
        <Center>
          <Box mt="2" w="32">
            <TextInput
              style={styles.input}
              testID={tID('SecretDevToolsTrigger-input')}
              onChangeText={handleChangeText}
            />
          </Box>
        </Center>
      )}
    </Box>
  );
}
